import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

export default function SkuflixBookmarkIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M17.1174 2.85938C17.6603 2.85938 18.1809 3.07503 18.5648 3.4589C18.9487 3.84277 19.1643 4.36341 19.1643 4.90629V20.2581C19.1643 20.4374 19.1171 20.6134 19.0277 20.7687C18.9382 20.924 18.8095 21.0531 18.6545 21.143C18.4995 21.233 18.3235 21.2806 18.1443 21.2812C17.9651 21.2818 17.7889 21.2354 17.6332 21.1465L13.0154 18.508C12.7062 18.3314 12.3562 18.2385 12.0001 18.2385C11.644 18.2385 11.2941 18.3314 10.9849 18.508L6.36703 21.1465C6.2114 21.2354 6.03516 21.2818 5.85594 21.2812C5.67671 21.2806 5.50079 21.233 5.34577 21.143C5.19074 21.0531 5.06206 20.924 4.97259 20.7687C4.88312 20.6134 4.836 20.4374 4.83594 20.2581V4.90629C4.83594 4.36341 5.05159 3.84277 5.43546 3.4589C5.81933 3.07503 6.33997 2.85938 6.88285 2.85938H17.1174Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
}
